export class FiltroArquivo {

	tipo: string;
	tipos: string[];
}